<app-fr-card>
  <h3 class="doc-title" *ngIf="userData && !vars.showStoryOnFundraiser && vars.pageName === 'stories'">
    <span>
      {{'Stories.documentText' | translatePipe | async}}
    </span>
  </h3>
  <div id="lightgalleryDocs" class="doc-container" *ngIf="userData || !vars.showStoryOnFundraiser || vars.pageName === 'stories'">
    <a *ngFor="let item of documents; let i=index" [href]="item?.cdn_path" class="doc-items" [attr.data-sub-html]="item?.detail_1" (click)="imgClick(item)">
      <img loading="lazy" class="doc-img" [attr.data-src]="item.cdn_path" [alt]="fundraiser?.title + '-' + item?.detail_1" />
    </a>
    <!-- <app-fb-share-card [sharedCounts]="sharedCounts"></app-fb-share-card> -->
  </div>
  <div *ngIf="!userData && vars.showStoryOnFundraiser && vars.pageName !== 'stories'" class="teest storyuiab">
    <div *ngIf="fundraiser?.viewmedicalbill.length === 0" class="med-doc-place-holder">
      <app-component-loader [load]="true" selector="app-med-doc-place-holder"
        [inputs]="{position: 'doc-tab', sharedCounts: sharedCounts, fundraiser: fundraiser, isFundraiserEnded: isFundraiserEnded, basicInfo: basicinfo}"
      />
    </div>
  </div>
  <div class="d-none d-sm-block" *ngIf="userData || !vars.showStoryOnFundraiser || vars.pageName === 'stories'">
    <div class="social-share">
      <app-whatsapp-share
                          label="Share" [count]="sharedCounts?.whatsapp" [fundraiser]="fundraiser"
                          [isFundraiserEnded]="isFundraiserEnded" [basicInfo]="basicInfo" [position]="3">
      </app-whatsapp-share>
      <app-fb-share label="Share" [count]="sharedCounts?.fb" [position]="3"></app-fb-share>
      <app-donate-now *ngIf="!isFundraiserEnded" label="Contribute Now" [fundraiser]="fundraiser" [position]="3"></app-donate-now>
    </div>
  </div>
</app-fr-card>


<app-signin-signup [popupView]="true" [numberOnly]="true" [showPopup]="openLoginPopup" [noRedirectAfterLogin]="true" (onClose)="signinClosed()" />

